import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Home from "./views/Home";
import History from "./views/History";
import NotFound from "./views/NotFound";
import "./App.css";
import Credits from "./views/Credits";
import Launches from "./views/Launches";
import Roadster from "./views/Roadster";
import Rockets from "./views/Rockets";
import Countdown from "./views/Countdown";

export default class App extends Component {
  render() {
    return (
      <div>
        <Router>
          <div>
            <Switch>
              <Route exact path="/" exact component={Home} />
              <Route exact path="/history" component={History} />
              <Route exact path="/credits" component={Credits} />
              <Route exact path="/launches" component={Launches} />
              <Route exact path="/roadster" component={Roadster} />
              <Route exact path="/rockets" component={Rockets} />
              <Route exact path="/countdown" component={Countdown} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}
